export default {
  pageTitle: {
    basic: 'Grundlegende Signaturdetails',
    social: 'Social Media Links',
    options: 'Signatur-Optionen',
    addons: 'Signatur-Addons',
    projects: 'Projekte'
  },
  sidebar: {
    basic: 'Basis',
    social: 'Sozial',
    options: 'Optionen',
    addons: 'Addons',
    projects: 'Projekte'
  }
}
